import React from "react";
import { DashboardStat } from "../../../../services/dashboardService";

interface StatCardProps {
  label: string;
  stat: DashboardStat;
  // Which direction of change is favorable — not uniform across cards (e.g.
  // more active users is good, more members at risk is bad).
  goodDirection?: "up" | "down";
}

const StatCard: React.FC<StatCardProps> = ({
  label,
  stat,
  goodDirection = "up",
}) => {
  const { value, previousValue } = stat;
  const delta = value - previousValue;
  const isGood = delta === 0 ? null : goodDirection === "up" ? delta > 0 : delta < 0;
  const colorClass =
    delta === 0 ? "text-gray-500" : isGood ? "text-green-600" : "text-red-600";
  const arrow = delta === 0 ? "—" : delta > 0 ? "▲" : "▼";
  const percentLabel =
    previousValue > 0
      ? `${Math.round((delta / previousValue) * 100)}%`
      : delta > 0
        ? "new"
        : null;

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <p className="text-gray-500 text-xs">{label}</p>
      <p className="text-gray-800 text-2xl font-bold mt-1">{value}</p>
      <p className={`text-xs mt-1 ${colorClass}`}>
        {arrow} {delta > 0 ? "+" : ""}
        {delta}
        {percentLabel ? ` (${percentLabel})` : ""} vs yesterday
      </p>
    </div>
  );
};

export default StatCard;
